import { useState } from "react";
import { cancelOrder } from "../services/orderService";
import { fetchAllEmployees } from "../services/employeeService";
import socket from "../socket/socket";

const CancelOrder = ({ orderId, onReRender }) => {
  const [isBusy, setIsBusy] = useState(false);
  const [popup, setPopup] = useState(false);
  const orderCancellation = async () => {
    const response = await cancelOrder(orderId);
    if (response?.data?.code === 1) {
      const employeeResponse = await fetchAllEmployees();
      if (employeeResponse.data.code === 1) {
        const employees = employeeResponse?.data?.data;
        socket.emit("merchant:dataUpdate", { employees: employees });
      }
      onReRender();
      setPopup(false);
      setIsBusy(false);
    }
  };
  return (
    <>
      <button
        onClick={() => {
          setPopup(true);
        }}
        className="btn btn-sm badge bg-danger-transparent ms-1 w-25 py-2"
      >
        <i className="ri-close-line me-1 fw-medium align-middle d-none d-md-inline"></i>
        CANCEL
      </button>
      <div
        className={
          popup === true
            ? "modal fade effect-slide-in-bottom show bg-success-transparent"
            : "modal fade effect-slide-in-bottom"
        }
        style={popup === true ? { display: "block" } : {}}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-sm"
          role="document"
        >
          <div className="modal-content modal-content-demo">
            <div className="modal-header">
              <h6 className="modal-title">CANCEL ORDER</h6>
              <button
                onClick={() => {
                  setIsBusy(false);
                  setPopup(false);
                }}
                aria-label="Close"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <div className="text-center h5">Are you sure?</div>
            </div>
            <div className="modal-footer">
              <div className="d-flex justify-content-center gap-2 w-100">
                <button
                  type="button"
                  onClick={() => {
                    setIsBusy(false);
                    setPopup(false);
                  }}
                  className="btn btn-danger"
                >
                  NO
                </button>
                <button
                  onClick={() => {
                    setIsBusy(true);
                    orderCancellation();
                  }}
                  type="button"
                  className="btn btn-primary"
                  disabled={isBusy === true ? true : false}
                >
                  {isBusy === true ? (
                    <span
                      className="spinner-border spinner-border-xs"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <>YES</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancelOrder;
